// Apply before queuing so online and offline starts use the same unassigned time.
export function unassignedClockInPayload(payload: Record<string, unknown> = {}): Record<string, unknown> {
  return { ...payload, project_id: null, activity: null, cost_center: null, work_type: 'work' };
}
